import script from "./FaqAccordion.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqAccordion.vue?vue&type=script&setup=true&lang=js"

import "./FaqAccordion.vue?vue&type=style&index=0&id=f7f554c2&lang=css"

const __exports__ = script;

export default __exports__